import Animation from "./Animation";
import { gsap, Sine } from "gsap";

/**
 * A custom element class for accessing window events and associated callbacks for animations
 * @extends Animation
 * @property {Function} animate the animation this class will run
 * @property {Function} setDefault set defaults for animation or element
 * @property {Function} onViewportEnter a callback function for intersection observer enter
 * @property {Function} onViewportExit a callback function for intersection observer exit
 */

class PositionedCandy extends Animation {

	/**
	 * Runs the animation
	 * @param {Function} done animation complete callback, passed into run()
	 */
	animate({ done }) {
		gsap.fromTo(this.element, {
			opacity: 0,
			translateY: `30px`
		}, {
			opacity: 1,
			delay: 0.3,
			duration: 0.6,
      translateY: 0,
			ease: "Power2.inOut",
		});
	}

	/**
	 * Will fire when element binds to the DOM, use this to
	 * set up default states if needed
	 */
	setDefault() {

		/** --- Settings --- */
		this.element.resetOnExit = true; // Run the animation in both directions of scroll

		/** --- Default states for animation or element can go in here --- */

	}

	/**
	 * Intersection Observer callback, only needs to fire this.run()
	 * this.run() can contain a callback function for done()
	 */
	onViewportEnter() {

		/** --- Fire the animation with a callback function for done() --- */
		this.run(() => {

		});
	}

	/**
	 * Intersection Observer callback for exit
	 * can be used to reset animation (timeline?)
	 */
	onViewportExit() {
		gsap.set(this.element, {opacity:0}) // prevent flicker when re-animating
	}
}

export default PositionedCandy;
